/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import ClientForm from './ClientForm';
import { formatDropDownValues } from '../../utils/formatters';

const filter = createFilterOptions();

class ClientAutocomplete extends ClientForm {
  constructor(props) {
    super(props);

    // ClientForm joins array data into a string; restore it as an array for multi-select
    if (props.multiple) {
      this.state = {
        ...this.state,
        data: Array.isArray(props.data) ? props.data : [props.data].filter(Boolean),
      };
    }
  }

  render() {
    const { multiple, allowNew, additionalOptions } = this.props;
    const baseOptions = this.state.attribute in this.state.structure
      ? this.state.structure[this.state.attribute].map((val) => String(val))
      : [];
    const normalizedAdditionalOptions = Array.isArray(additionalOptions)
      ? additionalOptions.filter(Boolean).map((val) => String(val))
      : [];
    const options = (normalizedAdditionalOptions.length
      ? [...new Set([...baseOptions, ...normalizedAdditionalOptions])]
      : baseOptions
    ).sort((a, b) => a.localeCompare(b));

    let value = this.state.data || null;
    if (multiple) {
      value = Array.isArray(this.state.data) ? this.state.data : [];
    }

    const stripAddPrefix = (val) => {
      if (typeof val === 'string' && val.startsWith('Add "') && val.endsWith('"')) {
        return val.slice(5, -1);
      }
      return val;
    };

    const handleChange = (event, newValue) => {
      const { setter, attribute, label } = this.state;
      let processed;
      if (allowNew) {
        processed = (Array.isArray(newValue) ? newValue.map(stripAddPrefix)
          : stripAddPrefix(newValue));
      } else {
        processed = newValue;
      }
      this.setState({ data: processed });
      setter(attribute, processed, label);
    };

    return (
      <div key={this.state.attribute}>
        {this.state.attribute in this.state.structure && (
          <>
            {!this.props.hideLabel && (
              <InputLabel
                variant="standard"
                htmlFor={this.state.attribute}
                required={this.state.required}
              >
                {this.state.label}
              </InputLabel>
            )}
            <Autocomplete
              id={this.state.attribute}
              multiple={multiple}
              freeSolo={allowNew}
              options={options}
              getOptionLabel={(option) => formatDropDownValues(this.state.attribute, option)}
              value={value}
              onChange={handleChange}
              disabled={this.state.isDisabled || this.props.isDisabled}
              disableClearable={this.state.required}
              isOptionEqualToValue={(option, val) => option === val}
              sx={{ width: this.props.customWidth || 300 }}
              filterOptions={allowNew ? (opts, params) => {
                const filtered = filter(opts, params);
                const { inputValue } = params;
                const isExisting = opts.some(
                  (opt) => opt.toLowerCase() === inputValue.toLowerCase(),
                );
                if (inputValue !== '' && !isExisting) {
                  filtered.push(`Add "${inputValue}"`);
                }
                return filtered;
              } : undefined}
              renderInput={(params) => (
                <TextField
                  {...params}
                  slotProps={{
                    ...params.slotProps,
                    htmlInput: {
                      ...params.slotProps?.htmlInput,
                      'data-testid': this.state.testingId,
                    },
                  }}
                />
              )}
            />
          </>
        )}
      </div>
    );
  }
}

export default ClientAutocomplete;
